export function isEmptyString(arg: string): boolean {
  return arg.length === 0;
}
